import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { TooltipDirectiveModule } from '../../../directives';
import { RewardsComponent } from './rewards.component';

@NgModule({
    imports: [
        TooltipDirectiveModule,
        CommonModule,
        SvgIconModule,
        RouterModule,
    ],
    exports: [ RewardsComponent ],
    declarations: [ RewardsComponent ],
    entryComponents: [ RewardsComponent ],
})
export class RewardsModule {}
